import Compatibilities from '../../../../components/compatibilities';
import compatibilities from './compatibilities';

export default compatibilities(Compatibilities);
